<template>
        <b-input-group :prepend="currentField.prepend ? currentField.prepend : ''" :append="currentField.append ? currentField.append : ''">
          <b-form-input  v-model="input"
            :name="storeInArray ? `formData${storeInArray}[${currentField.tagname}]` : `formData[${currentField.tagname}]`"
            v-bind="attributesBinding"
            :class="{'is-invalid' : error}"
            :type="currentField.showPassword ? 'password' : 'text'"
            :pattern="currentField.hasRegexValidation ? currentField.regex : null"
          ></b-form-input>
            <span class="invalid-feedback" role="alert" v-if="error">
                <strong>{{ error }}</strong>
            </span>
        </b-input-group>
</template>

<script>
export default {
  name: 'TextInput',
  props: ['currentField', 'storeInArray', 'value', 'error'],
  data() {
    return {
      input: this.value ? this.value : ''
    }
  },

  watch: {
    value (value) {
      this.input = value ?? ''
    },

    input(value) {
      this.$emit('updated', {
        key: this.currentField.tagname,
        value,
      })
    }
  },

  computed: {
    attributesBinding() {
      var attr = {};

      if (this.currentField.clearable) {
        attr.clearable = this.currentField.clearable;
      }

      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }

      if (this.currentField.showPassword) {
        attr.showPassword = this.currentField.showPassword;
      }

      if (this.currentField.isPlaceholderVisible) {
        attr.placeholder = this.currentField.placeholder;
      }

      if (this.currentField.minlength) {
        attr.minlength = this.currentField.minlength;
      }

      if (this.currentField.maxlength) {
        attr.maxlength = this.currentField.maxlength;
      }

      return attr;
    }
  }
}
</script>
